import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCheckCircle } from '@fortawesome/free-regular-svg-icons/faCheckCircle';
import { faRedo } from '@fortawesome/free-solid-svg-icons';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons/faChevronUp';
import { faCircle } from '@fortawesome/free-solid-svg-icons/faCircle';
import { faChevronDown as falChevronDown } from '@fortawesome/pro-light-svg-icons/faChevronDown';
import { faChevronUp as falChevronUp } from '@fortawesome/pro-light-svg-icons/faChevronUp';
import { NgbCollapseModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { SpinnerComponent } from 'src/app/components/common/spinner/spinner.component';
import { SpinnerModule } from 'src/app/components/common/spinner/spinner.module';
import { ContainerCollapsibleComponent } from 'src/app/components/container-collapsible/container-collapsible.component';
import { UiAddReduceButtonComponent } from 'src/app/components/ui/ui-add-reduce-button/ui-add-reduce-button.component';
import { UiApsSliderComponent } from 'src/app/components/ui/ui-aps-slider/ui-aps-slider.component';
import { UiCircleRadioWithCheckBoxListModule } from 'src/app/components/ui/ui-circle-radio-with-checkbox-list/ui-circle-radio-with-checkbox-list.module';
import { UiCircleRadioWithCheckboxComponent } from 'src/app/components/ui/ui-circle-radio-with-checkbox/ui-circle-radio-with-checkbox.component';
import { UiCircleRadioComponent } from 'src/app/components/ui/ui-circle-radio/ui-circle-radio.component';
import { UiCustomSwitchModule } from 'src/app/components/ui/ui-custom-switch/ui-custom-switch.module';
import { UiDaysPickerComponent } from 'src/app/components/ui/ui-days-picker/ui-days-picker.component';
import { UiDpmDropdownComponent } from 'src/app/components/ui/ui-dpm-dropdown/ui-dpm-dropdown.component';
import { UiDpmEnergyComponent } from 'src/app/components/ui/ui-dpm-energy/ui-dpm-energy.component';
import { UiDropDownComponent } from 'src/app/components/ui/ui-dropdown/ui-dropdown.component';
import { UiGroupCardComponent } from 'src/app/components/ui/ui-group-card/ui-group-card.component';
import { UiListCheckboxComponent } from 'src/app/components/ui/ui-list-checkbox/ui-list-checkbox.component';
import { UiRangeSliderComponent } from 'src/app/components/ui/ui-range-slider/ui-range-slider.component';
import { UiRectangleRadioComponent } from 'src/app/components/ui/ui-rectangle-radio/ui-rectangle-radio.component';
import { UiRoundedRectangleCustomRadioListModule } from 'src/app/components/ui/ui-rounded-rectangle-custom-radio-list/ui-rounded-rectangle-custom-radio-list.module';
import { UiRoundedRectangleRadioComponent } from 'src/app/components/ui/ui-rounded-rectangle-radio/ui-rounded-rectangle-radio.component';
import { UiRowSwitchComponent } from 'src/app/components/ui/ui-row-switch/ui-row-switch.component';
import { UiSwitchOnoffComponent } from 'src/app/components/ui/ui-switch-onoff/ui-switch-onoff.component';
import { UiSwitchTristateComponent } from 'src/app/components/ui/ui-switch-tristate/ui-switch-tristate.component';
import { UiTimePickerComponent } from 'src/app/components/ui/ui-time-picker/ui-time-picker.component';
import { UiToggleComponent } from 'src/app/components/ui/ui-toggle/ui-toggle.component';
import { UiTooltipsComponent } from 'src/app/components/ui/ui-tooltips/ui-tooltips.component';
import { SharedModule } from '../shared.module';
import { CommonMaterialModule } from './common-material.module';

@NgModule({
	declarations: [
		UiApsSliderComponent,
		UiCircleRadioComponent,
		UiCircleRadioWithCheckboxComponent,
		UiDaysPickerComponent,
		UiDropDownComponent,
		UiListCheckboxComponent,
		UiRangeSliderComponent,
		UiRectangleRadioComponent,
		UiRoundedRectangleRadioComponent,
		UiRowSwitchComponent,
		UiSwitchOnoffComponent,
		UiSwitchTristateComponent,
		UiSwitchTristateComponent,
		UiTimePickerComponent,
		ContainerCollapsibleComponent,
		UiTooltipsComponent,
		UiToggleComponent,
		ContainerCollapsibleComponent,
		UiDpmDropdownComponent,
		UiDpmEnergyComponent,
		UiAddReduceButtonComponent,
		UiGroupCardComponent,
	],
	exports: [
		UiApsSliderComponent,
		UiCircleRadioComponent,
		UiCircleRadioWithCheckboxComponent,
		UiDaysPickerComponent,
		UiDropDownComponent,
		UiListCheckboxComponent,
		UiRangeSliderComponent,
		UiRectangleRadioComponent,
		UiRoundedRectangleRadioComponent,
		UiRowSwitchComponent,
		UiSwitchOnoffComponent,
		SpinnerComponent,
		UiSwitchTristateComponent,
		UiSwitchTristateComponent,
		UiTimePickerComponent,
		ContainerCollapsibleComponent,
		UiTooltipsComponent,
		UiToggleComponent,
		ContainerCollapsibleComponent,
		UiDpmDropdownComponent,
		UiDpmEnergyComponent,
		UiAddReduceButtonComponent,
		UiCircleRadioWithCheckBoxListModule,
		UiRoundedRectangleCustomRadioListModule,
		UiCustomSwitchModule,
		CommonMaterialModule,
		UiGroupCardComponent,
	],
	imports: [
		CommonModule,
		SharedModule,
		RouterModule,
		NgbTooltipModule,
		NgbCollapseModule,
		FontAwesomeModule,
		UiCircleRadioWithCheckBoxListModule,
		UiRoundedRectangleCustomRadioListModule,
		UiCustomSwitchModule,
		SpinnerModule,
		CommonMaterialModule,
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class CommonUiModule {
	constructor(library: FaIconLibrary) {
		library.addIcons(faCircle);
		library.addIcons(faCheckCircle);
		library.addIcons(faChevronDown);
		library.addIcons(faRedo);
		library.addIcons(falChevronDown);
		library.addIcons(falChevronUp);
		library.addIcons(faChevronUp);
	}
}
